{
  "title": "瀏覽拍賣",
  "resultsCount": "{count} 件拍賣品",
  "noResults": "沒有符合篩選條件的拍賣。",
  "noneYet": "暫時沒有拍賣品。",
  "noneInCategory": "此分類暫時沒有進行中的拍賣。",
  "searchPlaceholder": "搜尋卡牌、公仔、服飾及更多…",
  "sortBy": "排序方式",
  "sort": {
    "endingSoon": "即將結束",
    "newest": "最新上架",
    "priceLow": "價格：由低至高",
    "priceHigh": "價格：由高至低"
  },
  "filters": {
    "category": "分類",
    "condition": "狀況",
    "grader": "鑑定公司",
    "grade": "評級",
    "priceRange": "價格範圍",
    "productType": "產品類型",
    "clearAll": "清除所有篩選"
  },
  "card": {
    "viewLot": "查看拍賣品",
    "watch": "加入追蹤清單",
    "unwatch": "從追蹤清單移除",
    "featured": "精選",
    "graded": "由 {company} 鑑定",
    "certNumber": "鑑定編號",
    "notVerified": "未經獨立核實",
    "currentBid": "目前出價",
    "starting": "起標價",
    "buyNow": "立即購買",
    "qty": "數量 {count}",
    "autographed": "有親筆簽名",
    "other": "其他"
  },
  "card360": {
    "heading": "360° 品相檢視",
    "badge": "賣家實拍 · 未經修圖",
    "sets": {
      "front_rotation": "正面",
      "back_rotation": "背面",
      "edge_inspection": "邊緣",
      "corner_inspection": "卡角",
      "surface_inspection": "表面"
    },
    "captureSets": {
      "front_rotation": "正面旋轉",
      "back_rotation": "背面旋轉",
      "edge_inspection": "邊緣",
      "corner_inspection": "卡角",
      "surface_inspection": "表面"
    },
    "hints": {
      "front_rotation": "每拍一張就把卡片轉少許，直至完成正面一整圈。",
      "back_rotation": "背面同樣處理，買家會用來判斷置中與印刷線。",
      "edge_inspection": "逐邊拍攝特寫，如實展示發白或崩邊。",
      "corner_inspection": "每個卡角一張清晰、光線充足的特寫。",
      "surface_inspection": "以斜角光線拍攝，顯示刮痕、凹陷或印刷瑕疵。"
    },
    "issues": {
      "blurred": "似乎模糊",
      "too_dark": "太暗",
      "overexposed": "反光／過曝",
      "dimension_mismatch": "尺寸與其他不同",
      "orientation_mismatch": "方向不一致",
      "duplicate": "與上一張幾乎相同",
      "too_large": "超過 8MB",
      "corrupt": "無法讀取的檔案",
      "bad_type": "不支援的格式"
    },
    "viewer": {
      "regionLabel": "360 度品相檢視",
      "groupLabel": "{title} — 360 度檢視，第 {index} / {count} 幀",
      "frameAlt": "{title} — 360° 第 {index} / {count} 幀",
      "loading": "載入中 {loaded} / {count} 幀",
      "dragToRotate": "拖曳以旋轉",
      "play": "播放旋轉",
      "pause": "暫停旋轉",
      "zoomIn": "放大",
      "zoomOut": "縮小",
      "fullscreen": "全螢幕開啟 360° 檢視",
      "closeFullscreen": "關閉全螢幕",
      "fullscreenTitle": "{title} — 360° 品相檢視",
      "failed": "無法載入 360° 影格。請檢查網絡連線後再試。"
    },
    "capture": {
      "toggleLabel": "啟用 360° 品相檢視",
      "description": "適用於未評級的原卡。買家可於出價前旋轉卡片，檢查卡角、邊緣與表面 — 具備 360° 拍攝的刊登轉換率明顯更高。",
      "guided": "引導拍攝",
      "upload": "上載連續相片",
      "clear": "清除此組",
      "progress": "{count} / {target} 幀",
      "minimum": "（最少 {min}）",
      "toReview": "{count} 張待檢查",
      "blocking": "部分影像無法使用 — 請於刊登前移除。",
      "unreadable": "無法讀取",
      "integrity": "影像會原樣儲存。對品相媒體加濾鏡、修圖或 AI 增強均違反賣家協議。",
      "frameAlt": "{label} 第 {index} 幀",
      "removeFrame": "移除第 {index} 幀",
      "cameraUnavailable": "無法使用相機 — 請改為上載相片序列。",
      "cameraPreview": "相機預覽",
      "frameOf": "第 {index} / {target} 幀 · 約旋轉至 {angle}°",
      "captureFrame": "拍攝此幀",
      "done": "完成",
      "closeCapture": "關閉拍攝"
    }
  }
}
